import { Helmet } from "react-helmet-async";

interface SEOProps {
  title: string;
  description: string;
  path: string;
  type?: string;
  noindex?: boolean;
  /**
   * Optional JSON-LD schema.org object(s) emitted as <script type="application/ld+json">.
   * Pass a single object or an array. Used by AI assistants (ChatGPT search,
   * Perplexity, Claude search, Google AI Overviews) to extract structured facts
   * from this specific page (e.g. FAQPage, Service, SoftwareApplication).
   */
  schema?: object | object[];
}

const SITE = "https://axoix.com";
const SITE_NAME = "AXOIX";
const OG_IMAGE = `${SITE}/og-image.png`;
const TWITTER = "@AXOIX_IN";

const SEO: React.FC<SEOProps> = ({ title, description, path, type = "website", noindex, schema }) => {
  const url = `${SITE}${path}`;
  const fullTitle = `${title} — ${SITE_NAME}`;
  const schemas = schema ? (Array.isArray(schema) ? schema : [schema]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:site_name" content={SITE_NAME} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={TWITTER} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />

      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
